import React, { Component } from "react";
import { Alert, Snackbar } from "@mui/material";

export class Alerts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            type: '',
            message: ''
        }
    }

    handleOpen(type, message) {
        this.setState({ open: true, type, message });
    }

    handleClose() {
        this.setState({ open: false });
    }

    render() {

        return (
            <Snackbar open={ this.state.open } autoHideDuration={ 6000 } onClose={ () => this.handleClose() } anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}>
                <Alert variant='filled' onClose={ () => this.handleClose() } severity={ !this.state.type ? 'success' : this.state.type } sx={{ width: '100%', fontWeight: 'bold' }}>
                    { this.state.message }
                </Alert>
            </Snackbar>
        )
    }
}